<script setup lang="ts">
const { location = 'bottom' } = defineProps<{
  location?: 'top' | 'bottom' | 'left' | 'right'
}>()
const popoverId = crypto.randomUUID() // Ensure random id to prevent potential conflicts

const anchorPositions = {
  bottom: {
    top: 'anchor(bottom)',
    left: 'anchor(center)',
    translate: '-50%',
  },
  top: {
    bottom: 'anchor(top)',
    left: 'anchor(center)',
    translate: '-50%',
  },
  left: {
    top: 'anchor(center)',
    right: 'anchor(left)',
    translate: '0 -50%',
  },
  right: {
    top: 'anchor(center)',
    left: 'anchor(right)',
    translate: '0 -50%',
  },
}
</script>
<template>
  <button
    :popovertarget="popoverId"
    :id="`trigger-${popoverId}`"
    popovertargetaction="toggle"
    anchor
  >
    <slot name="popoverTrigger" />
  </button>
  <div
    popover="auto"
    :id="popoverId"
    :style="anchorPositions[location]"
    :anchor="`trigger-${popoverId}`"
    class="absolute h-fit"
  >
    <slot name="popoverBody" />
  </div>
</template>
<style scoped>
[popover] {
  inset: unset;
}
</style>
